export default __webpack_public_path__ + "static/media/footer.c4fc021a.png";